import {useRouter} from 'next/router'

import useUserId from './useUserId'

export default function useForceLogin() {
  const userId = useUserId()
  const router = useRouter()

  if (!userId) {
    throw new Promise<void>(resolve => {
      router.replace({
        pathname: '/login',
        query: {nextPathname: router.asPath}
      })
      resolve()
    })
  }
}
